import React from "react";
import Header from "../../components/Header/Header";
import UserLibrary from "../../sections/UserLibrary/UserLibrary";
import "./Library.css";

function Library() {
  return (
    <main className="Library">
      <Header
        title="Keep the story going.."
        subtitle="Don't let your story end just yet. Continue reading your last book and immerse yourself in a world of literature."
        actionBtn="Start reading"
      />
      <UserLibrary />
    </main>
  );
}

export default Library;
